export default defineEventHandler((event) => {
  const url = event.node.req.url;
  if (url === "/sitemap.xml") {
    console.log("✅ Interception middleware : sitemap.xml détecté");
    return new Response(`<debug>intercepted in middleware</debug>`, {
      status: 200,
      headers: { "Content-Type": "application/xml" },
    });
  }

  return; // continue la chaîne normale
});
